import React from "react";
import { Box, Button, TextField } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import Uploader from "../../../../UI/Uploader/Uploader";
import { useUploader } from "../../../../../hooks/use-uploader";

export default function BannerEditForm({
  loading = false,
  banner,
  onChange,
  onSave
}) {

  const { upload } = useUploader()

  const {
    label,
    largeBanner,
    smallBanner
  } = banner

  const onUpdate = (key, newValue) => {
    onChange({
      ...banner,
      [key]: newValue
    })
  }

  const onUpload = async (
    key,
    file
  ) => {
    debugger
    // remove file
    if (!file) {
      onChange({
        ...banner,
        [key]: null,
        [`${key}Id`]: null
      })

      return
    }

    // upload
    const uploadedResult = await upload(file)
    if (uploadedResult) {
      const { url, id } = uploadedResult

      onChange({
        ...banner,
        [key]: url,
        [`${key}Id`]: id
      })
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        alignItems: "flex-start",
        flexWrap: "wrap",
        width: "100%",
        mb: 2,
      }}
    >

      <TextField
        label="Label"
        value={label}
        size="small"
        onChange={e => onUpdate("label", e.target.value)}
        sx={{ minWidth: 120, mt: 1 }}
      />

      <Uploader
        label="Large Banner"
        value={largeBanner}
        onChange={(file) => onUpload("largeBanner", file)}
        onRemove={() => onUpload("largeBanner", null)}
        size={100}
      />
      <Uploader
        label="Small Banner"
        value={smallBanner}
        onChange={(file) => onUpload("smallBanner", file)}
        onRemove={() => onUpload("smallBanner", null)}
        size={80}
      />
    </Box>
  );
}
